<template>
  <perfect-scrollbar>
    <div class="menu">
      <div class="menu-mainlist">
        <ul v-for="(list, category) in items" :key="category">
          <li v-if="category && category !=='main'" class="menu-category">{{ category }}</li>
          <TheMenuItem v-for="(item, index) in list" :key="index" :item="item" />
        </ul>
        <ul class="logout">
          <li>
            <b-nav-item v-on:click="logout">
              <i class="fas fa-sign-out-alt"></i>
              Wyloguj się
            </b-nav-item>
          </li>
        </ul>
      </div>
    </div>
  </perfect-scrollbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import TheMenuItem from "../components/TheMenuItem";

export default {
  name: "TheMenu",
  components: { TheMenuItem, PerfectScrollbar },
  computed: {
    ...mapGetters("user", ["hasAccess", "getRole"])
  },
  created() {
    let userRole = this.getRole;
    this.$router.options.routes.forEach(route => {
      //If category meta not exist then skip
      if (typeof route.meta.category === "undefined") return;
      if (route.meta.permission && this.hasAccess(route.meta.permission) === false ) return;
      if (route.meta.permission === 'subcontractorsView' && userRole === "subcontractor") return; //TMP fix
      let newItem = this.parseRoute(route);
      //Create container for category links
      if (!this.items[route.meta.category]) {
        this.items[route.meta.category] = [];
      }
      if (route.children) {
        newItem.children = [];
        route.children.forEach(children => {
          newItem.children.push(this.parseRoute(children));
        });
      }
      //Add links to category
      this.items[route.meta.category].push(newItem);
    });
  },
  data() {
    return {
      items: {}
    };
  },
  methods: {
    ...mapActions("user", ["logout"]),
    parseRoute(route) {
      return {
        name: route.name,
        path: route.path,
        icon: route.meta.icon,
        permission: route.meta.permission
      };
    }
  }
};
</script>